'use client';

import { c as _c } from "react/compiler-runtime";
import { checkAccess, useAuth } from '@repo/auth';
import { SidebarGroup, SidebarGroupLabel, SidebarMenu } from '@repo/ui/components';
import { LucideIcon } from '@repo/ui/icons';
import { ReactNode } from 'react';
import { CollapsibleMenu } from '@/app/@protected/_components/sidebar/collapsible-menu.tsx';
import { LinkMenu } from '@/app/@protected/_components/sidebar/link-menu.tsx';
export type AccessRequirement = {
  match?: 'all' | 'any';
  permissions?: string[];
  roles?: string[];
};
export type NavContent = {
  items: SidebarItem[];
  label?: Label;
};
export type SidebarItem = {
  access?: AccessRequirement;
  groupUrl?: string;
  icon?: LucideIcon;
  isActive?: boolean;
  items?: {
    title: string;
    url: string;
  }[];
  title: string;
  url: string;
};
type Label = {
  options?: ReactNode;
  title: string;
};
export const AppSidebarContent = t0 => {
  const $ = _c(29);
  const {
    items,
    label
  } = t0;
  const {
    user
  } = useAuth();
  let T0;
  let T1;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== items || $[1] !== label || $[2] !== user) {
    t8 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t9;
      if ($[13] !== user) {
        t9 = item => !item.access || checkAccess(user, item.access).allowed;
        $[13] = user;
        $[14] = t9;
      } else {
        t9 = $[14];
      }
      const visibleItems = items.filter(t9);
      if (visibleItems.length === 0) {
        t8 = null;
        break bb0;
      }
      T1 = SidebarGroup;
      t4 = "SidebarGroup";
      t5 = "AppSidebarContent";
      t6 = "sidebar-content.tsx";
      if ($[15] !== label) {
        t7 = label && <SidebarGroupLabel className="justify-between">{label.title} {label.options && label.options}</SidebarGroupLabel>;
        $[15] = label;
        $[16] = t7;
      } else {
        t7 = $[16];
      }
      T0 = SidebarMenu;
      t1 = "SidebarMenu";
      t2 = "sidebar-content.tsx";
      t3 = visibleItems.map(_temp);
    }
    $[0] = items;
    $[1] = label;
    $[2] = user;
    $[3] = T0;
    $[4] = T1;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    T0 = $[3];
    T1 = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
  }
  if (t8 !== Symbol.for("react.early_return_sentinel")) {
    return t8;
  }
  let t9;
  if ($[17] !== T0 || $[18] !== t1 || $[19] !== t2 || $[20] !== t3) {
    t9 = <T0 data-sentry-element={t1} data-sentry-source-file={t2}>{t3}</T0>;
    $[17] = T0;
    $[18] = t1;
    $[19] = t2;
    $[20] = t3;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== T1 || $[23] !== t4 || $[24] !== t5 || $[25] !== t6 || $[26] !== t7 || $[27] !== t9) {
    t10 = <T1 data-sentry-element={t4} data-sentry-component={t5} data-sentry-source-file={t6}>{t7}{t9}</T1>;
    $[22] = T1;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};
function _temp(item_0) {
  return item_0.items ? <CollapsibleMenu {...item_0} key={item_0.title} /> : <LinkMenu {...item_0} key={item_0.title} />;
}